import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    Grid,
    TextField,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    FormControl,
    Select,
    MenuItem,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    InputLabel,
    Divider,
    CircularProgress,
    InputAdornment,
    Autocomplete,
} from "@material-ui/core";
import { HelpOutline } from "@material-ui/icons";
import Tooltip from "@mui/material/Tooltip";
import { makeStyles } from "@material-ui/styles";
import Card from "../../StyledComponents/Card/Card";
import CardHeader from "../../StyledComponents/Card/CardHeader";
import CardText from "../../StyledComponents/Card/CardText";
import CardBody from "../../StyledComponents/Card/CardBody";
import { useMediaQuery } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import LockResetIcon from "@mui/icons-material/LockReset";
import CustomSnackbar from "../../CustomSnackbar";
import TabelSkeleton from "../../StyledComponents/TableSkeleton";
import axios from "axios";
import { Person, RemoveRedEye, VisibilityOff } from "@material-ui/icons";
import EmptyData from "../../StyledComponents/Table/EmptyData";

import { Backdrop } from "@material-ui/core";
const ITEM_HEIGHT = 40;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const useStyles = makeStyles({
    table: {
        "& .MuiTableCell-root": {
            borderLeft: "1px solid rgba(224, 224, 224, 1)",
        },
    },
});
function ReportAddUser() {
    const matches = useMediaQuery("(max-width:700px)");
    const [openModel, setOpenModel] = useState(false);
    const [togglebutton, settogglebutton] = useState(null);
    const [getuser, setGetUser] = useState([]);
    const [username, setusername] = useState("");
    const [userEmail, setuserEmail] = useState("");
    const [password, setpassword] = useState("");
    const [userloader, setUserLoader] = useState(false);
    const [userId, setuserId] = useState("");
    const [statusLoading, setStatusLoading] = useState(false);
    const [roleoptions, setRoleoptions] = useState([]);
    const [error, seterror] = useState(true);
    const [errorMessage, setErrorMessage] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const classes = useStyles();
    const [searchInput, setSearchInput] = useState("");
    const [reportId, setReportID] = useState(null);
    const [personRoles, setPersonRoles] = React.useState([]);
    const [deleteId, setDeleteID] = useState("");
    const [passwordmodel, setPasswordModel] = useState(false);
    const [confirm, setConfirm] = useState("");
    const [passwordID, setPasswordID] = useState("");

    const [showPassword, setShowPassword] = useState(false);
    const [showConPassword, setConShowPassword] = useState(false);
    const [searchApi, setSearchAPi] = useState([]);
    const [employeePersonalNumber, setEmployeePersonalNumber] = useState("");
    const [get_Employee, setGetEmployee] = useState([]);

    const handleSearchInput = (e) => {
        const inputValue = e.target.value;

        if (inputValue === "") {
            setGetUser(searchApi);
        } else {
            const fiterData = searchApi.filter(
                (data) =>
                    data.reportName.toLowerCase().includes(inputValue.toLowerCase()) || data.roleName.toLowerCase().includes(inputValue.toLowerCase())
            );
            if (fiterData.length > 0) {
                setGetUser(fiterData);
            } else {
                let msg = "No Records Found";
                setGetUser([{ message: msg }]);
            }
        }
    };
    const handleOpenModel = () => {
        setOpenModel(true);
    };
    const handleCloseModel = () => {
        setOpenModel(false);
    };
    const get_role_data = () => {
        var config = {
            method: "get",
            url: `${process.env.REACT_APP_API_URL}/api/Role/getAllRoles`,
            headers: {
                Authorization: `Bearer ${localStorage.getItem("user_token")}`,
            },
        };

        axios(config)
            .then(function (response) {
                setRoleoptions(response.data);
            })
            .catch(function (error) { });
    };
    const get_user = () => {
        setStatusLoading(true);
        var config = {
            method: "get",
            url: `${process.env.REACT_APP_API_URL}/api/ReportRole/GetAllReportsWithRoles`,
            headers: {
                Authorization: `Bearer ${localStorage.getItem("user_token")}`,
            },
        };

        axios(config)
            .then(function (response) {
                setGetUser(response.data);
                setSearchAPi(response.data);
                setStatusLoading(false);
            })
            .catch(function (error) { });
    };
    const update_user = (reportId) => {
        console.log("data role", personRoles);
        console.log("reportId", reportId);
        var config = {
            method: "put",
            url: `${process.env.REACT_APP_API_URL}/api/ReportRole/UpdateReportRoles/${reportId}`,
            headers: {
                Authorization: `Bearer ${localStorage.getItem("user_token")}`,
                "Content-Type": "application/json",
            },
            data: personRoles
        };

        axios(config)
            .then(function (response) {
                get_user();


                setOpenModel(false);
            })
            .catch(function (error) {
                setUserLoader(false);

                setErrorMessage(error?.response?.data?.message);
            });
    };
    useEffect(() => {
        get_user();
        get_role_data();
    }, []);
    return (
        <div>

            <Card style={{ marginTop: "24px" }}>
                <CardHeader color="primary" text>
                    <CardText color="primary" style={{ padding: "0px 27px" }}>
                        {/* <Box> */}
                        <h4>Manage Report Role</h4>

                        {/* </Box> */}
                    </CardText>
                </CardHeader>
                <CardBody>

                    <Grid container spacing={2} pb={3}>
                        <Grid item md={4} sx={3} mt={2} ml={1}>
                            <TextField
                                size="small"
                                fullWidth
                                type="search"
                                id="outlined-basic"
                                placeholder="Search here...."
                                variant="outlined"
                                value={searchInput}
                                onInput={(e) => {
                                    handleSearchInput(e);
                                    setSearchInput(e.target.value);
                                }}
                            />
                        </Grid>
                    </Grid>

                    <TableContainer
                        className="scrollable"
                        sx={{
                            height: 500,
                        }}
                    >
                        <Table
                            className={classes.table}
                            aria-label="a dense table"
                            style={{ padding: "0px 27px" }}
                            // padding="normal"
                            size="small"
                            sx={{
                                height: "max-content",
                            }}
                        >
                            <TableHead
                                style={{
                                    position: "sticky",
                                    top: "0px",
                                }}
                            >
                                <TableRow sx={{ backgroundColor: "#A5ACB0" }}>
                                    <TableCell
                                        sx={{ fontWeight: "bold", color: "#fff", width: 300 }}
                                    >
                                        SR#
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: "bold", color: "#fff" }}>
                                        Report Name
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: "bold", color: "#fff" }}>
                                        Roles
                                    </TableCell>

                                    <TableCell
                                        align="right"
                                        sx={{ fontWeight: "bold", color: "#fff" }}
                                    >
                                        Action
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {getuser.map((item, index) => {
                                    return (
                                        <>
                                            {item.message ? (
                                                <>
                                                    <TableRow>
                                                        <TableCell
                                                            colSpan={6}
                                                            style={{
                                                                border: "none",
                                                                textAlign: "center",
                                                                padding: "20px 10px 20px",
                                                            }}
                                                        >
                                                            <Typography>No Records Found</Typography>
                                                        </TableCell>
                                                    </TableRow>
                                                </>
                                            ) : (
                                                <TableRow key={1}>
                                                    <TableCell scope="row">{index + 1}</TableCell>
                                                    <TableCell>{item.reportName}</TableCell>
                                                    <TableCell>{item.roleName}</TableCell>
                                                    <TableCell align="right">
                                                        <Tooltip title="Edit">
                                                            <EditIcon
                                                                color="success"
                                                                sx={{ "&:hover": { cursor: "pointer" } }}
                                                                onClick={() => {
                                                                    setPersonRoles((item?.roleId?.split(",") || []).map(role => role.trim()));
                                                                    setReportID(item?.reportId)
                                                                    handleOpenModel();
                                                                }}
                                                            />
                                                        </Tooltip>
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                        </>
                                    );
                                })}
                            </TableBody>
                            {statusLoading && <TabelSkeleton noOfColumns={4} noOfLines={5} />}
                        </Table>
                        {getuser?.length === 0 && !statusLoading ? <EmptyData /> : ""}
                    </TableContainer>
                </CardBody>
            </Card>

            {/* //!Model for Add user */}
            <Dialog
                open={openModel}
                onClose={handleCloseModel}
                // sx={{ width: "60%" }}
                fullWidth={togglebutton ? true : false}
            >
                {deleteId ? (
                    <>
                        <DialogContent>
                            <Backdrop
                                sx={{
                                    color: "#fff",
                                    zIndex: (theme) => theme.zIndex.drawer + 1,
                                }}
                                open={userloader}
                            >
                                <CircularProgress color="inherit" />
                            </Backdrop>

                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    textAlign: "center",
                                }}
                            >
                                <HelpOutline color="secondary" fontSize="large" mt={2} />
                            </Box>
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    textAlign: "center",
                                }}
                                p={2}
                                mt={1}
                            >
                                <Typography variant="h4" style={{ width: "80%" }}>
                                    Are you sure you want to Delete a User?
                                </Typography>
                            </Box>
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    textAlign: "center",
                                }}
                                m={1}
                            >
                                <Button
                                    variant="outlined"
                                    color="secondary"
                                    onClick={handleCloseModel}
                                >
                                    NO
                                </Button>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    style={{ marginLeft: "20px" }}

                                >
                                    Yes
                                </Button>
                            </Box>
                        </DialogContent>
                    </>
                ) : (
                    <>
                        <form style={{ width: "500px" }}>
                            <DialogTitle
                                sx={{
                                    fontWeight: "bold",
                                    fontSize: "20px",
                                }}
                            >
                                Edit Role
                            </DialogTitle>
                            <Divider />
                            <DialogContent>
                                <Backdrop
                                    sx={{
                                        color: "#fff",
                                        zIndex: (theme) => theme.zIndex.drawer + 1,
                                    }}
                                    open={userloader}
                                >
                                    <CircularProgress color="inherit" />
                                </Backdrop>

                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={12} md={12} lg={12}>
                                        <FormControl fullWidth size="small">
                                            <InputLabel id="demo-simple-select-label">
                                                Select Role
                                            </InputLabel>
                                            <Select
                                                displayEmpty
                                                labelId="demo-multiple-name-label"
                                                id="demo-multiple-name"
                                                multiple
                                                label="Select Role"
                                                value={personRoles}
                                                onChange={(event) => {
                                                    // setuserRole(event.target.value);
                                                    const {
                                                        target: { value },
                                                    } = event;
                                                    console.log("value", value)
                                                    setPersonRoles(
                                                        typeof value === "string" ? value.split(",") : value
                                                    );
                                                }}
                                                MenuProps={MenuProps}
                                            >
                                                {roleoptions.map((item) => (
                                                    <MenuItem value={item.id}>{item.name}</MenuItem>
                                                ))}
                                            </Select>
                                            {!error && personRoles.length === 0 ? (
                                                <>
                                                    <Typography variant="h6" component="h6" color="error">
                                                        user role is required
                                                    </Typography>
                                                </>
                                            ) : null}
                                        </FormControl>
                                    </Grid>

                                </Grid>

                            </DialogContent>
                            <Divider />

                            <DialogActions>
                                <Button
                                    variant="outlined"
                                    color="error"
                                    onClick={handleCloseModel}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    color="success"
                                    variant="contained"
                                    onClick={() => {
                                        update_user(reportId);
                                    }}
                                >
                                    Updated
                                </Button>
                            </DialogActions>
                        </form>
                    </>
                )}
            </Dialog>


            {/* //! for listing Table */}
            {successMessage && (
                <CustomSnackbar
                    open={true}
                    message={successMessage}
                    handleClose={() => setSuccessMessage("")}
                    variant="success"
                />
            )}
            {errorMessage && (
                <CustomSnackbar
                    open={errorMessage !== ""}
                    message={errorMessage}
                    handleClose={() => setErrorMessage("")}
                    variant="error"
                />
            )}
        </div>
    );
}

export default ReportAddUser;

